import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4H7.6V19.2H2V4ZM9.20038 9.6001H14.8004V19.2001H9.20038V9.6001ZM21.9997 14.3999H16.3997V19.1999H21.9997V14.3999Z"
      fill="#38D695"
    />
  </svg>
);
const SvgBarColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgBarColored;
